import { API, Buffer } from '../core';

export class TeesterBackend {
    constructor (options = {}) {
        this.type = 'backend';
        this.options = options;
    }

    /**
     * Called by i18next
     */
    init () {
        const { url, template, cacheDuration } = this.options;
        this.api = new API({ url, template, cacheDuration });
        this.buffer = new Buffer({ onFlush: this.api.reportMissing.bind(this.api) });
    }

    /**
     * Fetch a single resource
     */
    read (language, namespace, callback) {
        this.readMulti([language], [namespace], (err, data) => {
            if (err) {
                callback(err, null);
            } else {
                callback(null, data[language][namespace]);
            }
        })
    }

    /**
     * Fetch multiple resources at once
     */
    readMulti (languages, namespaces, callback) {
        this.api.getI18n(languages)
            .then((data) => {
                // Add a nesting level for each requested namespace
                const namespacedData = Object.fromEntries(
                    Object.entries(data).map(([language, values]) => [
                        language,
                        Object.fromEntries(namespaces.map((namespace) => [namespace, values])),
                    ]),
                );

                callback(null, namespacedData);
            })
            .catch((err) => callback(err, null));
    }

    /**
     * Report missing key
     */
    create (languages, namespace, key) {
        this.buffer.add(key);
    }
}
